import axios from 'axios';
import config from '../config';
import { RouteCardsQueryParams, RouteCardsResponse } from '../interfaces';

export const DEFAULT_ROUTE_CARDS_PAGE_SIZE = 25;

export const getRouteCards = (
    params: RouteCardsQueryParams,
    signal?: AbortSignal,
): Promise<RouteCardsResponse> => {
    return axios.get(`${config.API_URL}/route-cards`, { params, signal }).then((response: any) => {
        const data = response.data.data;

        return {
            items: data.items,
            pagination: data.pagination,
        };
    });
};
